import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <div class="contact-container">
      <p class="contact-text">
        Call centre number +91 7400088941/022-42022190 | Customer Service Email
        ID{" "}
        <a href="mailto: prepaid.service@nsdlbank.co.in">
          {" "}
          prepaid.service@nsdlbank.co.in{" "}
        </a>{" "}
        | Grevience Officer Email ID{" "}
        <a href="mailto: nodalofficer@nsdlbank.co.in">
          {" "}
          nodalofficer@nsdlbank.co.in{" "}
        </a>
        <br></br>Communication timings available between Monday to Friday 10:00
        AM to 06:00 PM | Powered by PayCraft
      </p>
    </div>
  );
};

export default Footer;
